import { render } from "./DettaglioAzienda.vue?vue&type=template&id=7a3ee52e&ts=true"
import script from "./DettaglioAzienda.vue?vue&type=script&lang=ts"
export * from "./DettaglioAzienda.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__